import React from 'react';
import { Controller, Menu } from '@tencent/workbench';
import { MENU_CONFIGS } from '@framework/workbench/ui/accessibility/config';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { getAccessibilityDescription } from '@editor/src/js/constants/top-menu-data';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { TitlebarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import { AccessibilityFeature } from '@framework/workbench/ui/accessibility/accessibility-feature';

@Controller({ menuItems: MENU_CONFIGS })
export class AccessibilityController {
    public constructor(private readonly feature: AccessibilityFeature) {}

    @Menu(ActionType.ACCESSIBILITY, 'onClick')
    public showAccessibility() {
        this.feature.getAppService().viewableServiceLayer.accessibilityManager.promise()
            .then((a11yManager) => {
                a11yManager.showAccessibilityModal();
            });
    }

    @Menu(ActionType.ACCESSIBILITY, 'description')
    public getDescription() {
        return getAccessibilityDescription();
    }

    @Menu(ActionType.ACCESSIBILITY, 'content')
    public getContent() {
        const { AccessibilityToggle } = this.feature;
        return <AccessibilityToggle
            a11yManager={this.feature.getAppService().viewableServiceLayer.accessibilityManager}
        />;
    }

    @Menu(ActionType.ACCESSIBILITY, 'shouldHide')
    public handleHide() {
        return !!(appConfigInstance.getConfig(TitlebarFileMenuConfig.simplifyMode as any) ?? false);
    }
}
